const getGS = () => window.__canvasGlobalScope
const getIframeWindow = () => {
  const iframe = document.getElementById('canvas-iframe')
  return iframe?.contentWindow || window
}

export const ZoomInNavbar = {
  flow: 'x',
  onFrame: (el) => {
    const pz = getGS()?.panzoomInstance
    const scale = pz ? pz.getTransform().scale : 0.35
    const text = parseInt(scale * 100) + '%'
    if (el.Box && el.Box.node && el.Box.node.innerText !== text) {
      el.Box.node.innerText = text
    }
  },
  align: 'center',
  NavbarButton_out: {
    title: 'Zoom out',
    icon: 'sf zoom out',
    ':not(:hover)': {
      theme: 'transparent'
    },
    onClick: (ev, el) => {
      const gs = getGS()
      if (!gs?.panzoomInstance) return
      const win = getIframeWindow()
      const { x, y } = gs.positions
      gs.panzoomInstance.smoothZoom(
        x + win.innerWidth / 2,
        y + win.innerHeight / 2,
        0.75
      )
    }
  },
  Box: {
    width: '7ch',
    textAlign: 'center',
    padding: '- Z',
    fontSize: 'Z2',
    color: 'paragraph',
    text: '100%',
    userSelect: 'none',
    onDblclick: (ev, el) => {
      const gs = getGS()
      if (!gs?.panzoomInstance) return
      const win = getIframeWindow()
      const { x, y } = gs.positions
      gs.panzoomInstance.smoothZoomAbs(
        x + win.innerWidth / 2,
        y + win.innerHeight / 2,
        1
      )
    }
  },
  NavbarButton_in: {
    title: 'Zoom in',
    icon: 'sf zoom in',
    ':not(:hover)': {
      theme: 'transparent'
    },
    onClick: (ev, el) => {
      const gs = getGS()
      if (!gs?.panzoomInstance) return
      const win = getIframeWindow()
      const { x, y } = gs.positions
      gs.panzoomInstance.smoothZoom(
        x + win.innerWidth / 2,
        y + win.innerHeight / 2,
        1.25
      )
    }
  },
  DropdownArrow: {
    margin: '- - - X2'
  }
}
